import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/security'

class AuthService {
  login(user) {
    return axios
      .post(API_URL + '/sign-in/admin', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        if (response.data.accessToken) {
          this.loadAuthResponse(response)
        }

        return response.data
      })
  }

  refreshToken() {
    const authUser = JSON.parse(localStorage.getItem('auth_user'))
    return axios
      .post(API_URL + '/refresh/admin', {
        refreshToken: authUser.refreshToken
      })
      .then(response => {
        if (response.data.accessToken) {
          this.loadAuthResponse(response)
          return true
        }

        return false
      })
      .catch(error => {
        this.logout()
      })
  }

  loadAuthResponse(response) {
    localStorage.setItem('auth_user', JSON.stringify(response.data))
    const payload = jwtDecode(response.data.accessToken)
    if (payload._adminRoleSuperadmin) {
      localStorage.setItem('auth_superadmin', payload._adminRoleSuperadmin)
    }
    if (payload._adminRoleEditor) {
      localStorage.setItem('auth_editor', payload._adminRoleEditor)
    }
    localStorage.setItem('auth_role_manager', localStorage.getItem('auth_role_manager'))
    localStorage.setItem('auth_role_branch', localStorage.getItem('auth_role_branch'))
    localStorage.setItem('auth_role_employee', localStorage.getItem('auth_role_employee'))
    const now = new Date()
    localStorage.setItem(
      'auth_user_validity',
      now.setSeconds(now.getSeconds() + response.data.expireIn)
    )
  }

  forgotPassword(user) {
    return axios
      .post(API_URL + '/reset-password/admin/request', {
        email: user.email
      })
      .then(response => {
        return response.data
      })
  }

  forgotPasswordProcess(request) {
    return axios
      .post(API_URL + '/reset-password/admin', request)
      .then(response => {
        return response.data
      })
  }

  signUp(request) {
    return axios.post(API_URL + '/sign-up/admin', request).then(response => {
      return response.data
    })
  }

  logout() {
    localStorage.clear()
  }

  setRole(provider, branch, employee) {
    localStorage.setItem('auth_role_manager', provider)
    localStorage.setItem('auth_role_branch', branch)
    localStorage.setItem('auth_role_employee', employee)
  }
}

export default new AuthService()
